<template>
  <router-link
    class="vf-a-link"
    :to="to ? to : '/'"
    :rel="hasNonIndexableCatalogQuery(to) ? 'nofollow' : undefined"
  >
    <slot></slot>
  </router-link>
</template>
<script lang="ts" setup>
import { PropType } from "vue";
import { hasNonIndexableCatalogQuery } from "../../../utils/canonicalPath";

defineProps({
  to: {
    type: [String, Object] as PropType<string | object>,
    default() {
      return "/";
    },
  },
});
</script>
